module.exports = __webpack_public_path__ + "static/media/fs-reuploaded.f2a00e5f.png";